module.exports = __webpack_public_path__ + "img/menuIcon6.71d6a219.png";